import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=5851544e&scoped=true"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=5851544e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5851544e",
  null
  
)

export default component.exports